const SEEN_HOME_KEY = 'sco.advisors.seenHomeOrientation'
const SEEN_DUAL_TIP_KEY = 'sco.advisors.seenDualRoleTip'

const readFlag = (key: string): boolean => {
  if (typeof window === 'undefined') {
    return false
  }
  try {
    return window.localStorage.getItem(key) === '1'
  } catch {
    return false
  }
}

const writeFlag = (key: string) => {
  if (typeof window === 'undefined') {
    return
  }
  try {
    window.localStorage.setItem(key, '1')
  } catch {
    /* private mode / blocked storage */
  }
}

export const hasSeenAdvisorsHomeOrientation = () => readFlag(SEEN_HOME_KEY)

export const markAdvisorsHomeOrientationSeen = () => writeFlag(SEEN_HOME_KEY)

export const hasSeenDualRoleTip = () => readFlag(SEEN_DUAL_TIP_KEY)

export const markDualRoleTipSeen = () => writeFlag(SEEN_DUAL_TIP_KEY)

/** Skip `/advisors` → Ask only after the map has been seen and Wil has been used. */
export const shouldSkipHomeToWil = ({
  isRegistered,
  isLoading,
  isWilMessageLimited,
  hasSeenOrientation,
  hasUsedWil,
}: {
  isRegistered: boolean
  isLoading: boolean
  isWilMessageLimited: boolean
  hasSeenOrientation: boolean
  hasUsedWil: boolean
}): boolean => isRegistered && !isLoading && isWilMessageLimited && hasSeenOrientation && hasUsedWil
